import TemplateView from '../../../../TemplateView'
import EffectiveDateCell from './EffectiveDateCell'
import messageResource from '../../../../messageResource'
import WorkdayDurationsEditor from '../../../../controls/WorkdayDurationsEditor'
import CustomCheckbox from '../../../../components/customCheckbox/CustomCheckbox'
import UserTime from '../../../../user_time'
import DeleteConfirmationCell from '../DeleteConfirmationCell'
import {getInstance as getModalAlert} from '../../UserPanelModalAlert'
import {ModalAlertPointerPosition} from '../../../../components/modalAlert/constants'
import {ValidationErrors} from '../../constants'
import {ShowWarning} from '../userRates/constants'

export default class WorkScheduleRow extends TemplateView {
    constructor({
        readOnly = false,
        showWarning = false,
        scrollTo = () => {},
        onChangeCb = () => {},
        onDeleteCb = () => {},
        rollbackEffectiveDateChanges = () => {},
        subscribeSelectorOnScroll = () => {},
    }) {
        super()

        this.params = {
            readOnly,
            showWarning,
            scrollTo,
        }

        this.callbacks = {
            onChangeCb,
            onDeleteCb,
            rollbackEffectiveDateChanges,
            subscribeSelectorOnScroll,
        }

        this.state = {
            oldEffectiveDate: null,
            effectiveDate: null,
            durations: [],
            weekStartDay: null,
            invertedDays: {},
            defaultWorkSchedule: [],
            useDefaultSchedule: false,
            currentDate: (new Date()).toJSON(),
            effective: false,
            error: null,
            readOnly: this.params.readOnly,
        }

        this.onAnyStatePropertyChanged([
                'effectiveDate', 'durations', 'weekStartDay', 'invertedDays',
                'defaultWorkSchedule', 'useDefaultSchedule', 'currentDate', 'effective', 'readOnly'
            ], () => this._update()
        )

        this.onStatePropertyChanged('error', error => this._updateError(error))
    }

    messageKeys() {
        return {
            usedCorporateSettings: 'user.add_edit.js.wd_editor.used_corporate_settings',
        }
    }

    templateHtml() {
        return '<div class="workScheduleRow">' +
               '    <div class="workSchedule">' +
               '        <div class="headerCell"/>' +
               '        <div class="workScheduleEditorCell"/>' +
               '        <div class="totalCell"/>' +
               '        <div class="useDefaultScheduleCell">' +
               '            <div class="usedDefaultScheduleLabel"><%-usedCorporateSettings%></div>' +
               '        </div>' +
               '        <div class="deleteButtonCell">' +
               '            <div class="deleteIcon"/>' +
               '        </div>' +
               '    </div>' +
               '    <div class="deleteConfirmationContainer"/>' +
               '</div>'
    }

    afterRender() {
        this.$workschedule = this.find('.workSchedule')
        this.$deleteCell = this.find('.deleteButtonCell')
        this.$usedDefaultScheduleLabel = this.find('.usedDefaultScheduleLabel')

        this.effectiveDate = new EffectiveDateCell({
            dateFromLabel: messageResource.getMessage('user.add_edit.js.wd_editor.effective_date_prefix'),
            readOnly: this.params.readOnly,
            scrollTo: this.params.scrollTo,
            onChangeCb: effectiveDate => this._handleScheduleChanged({effectiveDate}),
            rollbackChanges: this.callbacks.rollbackEffectiveDateChanges,
            subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll,
        }).init(this.find('.headerCell'))

        this.$workdayDurationsPlaceholder = this.find('.workScheduleEditorCell')

        this.$totalCell = this.find('.totalCell')

        this.useDefaultScheduleCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('user.add_edit.js.wd_editor.use_corporate_settings'),
            containerAdditionalClass: 'useDefaultScheduleCheckbox',
            onChange: ({checked}) => this._handleScheduleChanged({useDefaultSchedule: checked}),
        }).init(this.find('.useDefaultScheduleCell'))

        this.$deleteCell.toggle(!this.params.readOnly)

        this.find('.deleteIcon').click(e => {
            e.stopPropagation()

            if (this.state.effectiveDate === null) {
                this.callbacks.onDeleteCb({removePermanently: true})
            } else {
                this._toggleDeleteConfirmation(true)
            }
        })

        this.$deleteConfirmationContainer = this.find('.deleteConfirmationContainer').hide()
    }

    _update() {
        this.$workschedule.toggleClass('effective', this.state.effective)

        this.effectiveDate.setState({
            invertedDays: this.state.invertedDays,
            weekStartDay: this.state.weekStartDay,
            defaultWorkSchedule: this.state.defaultWorkSchedule,
            date: this.state.effectiveDate,
            effective: this.state.effective,
        })

        this.$workdayDurationsPlaceholder.empty()

        this.workdayDurationsEditor = new WorkdayDurationsEditor().init(
            [...this.state.durations],
            this.state.weekStartDay,
            () => {
                if (this.workdayDurationsEditor.hasErrors()) {
                    this._handleWorkdayDurationEditorError()
                } else {
                    this._handleScheduleChanged({
                        useDefaultSchedule: false,
                        durations: this.workdayDurationsEditor.getDurations()
                    })
                }
            },
            false,
            null,
            window.SystemSettings.decimalSeparator,
            this.state.readOnly,
        )
        const showCorporateCheckbox = !this.state.readOnly
                                      && this.state.effectiveDate !== null
                                      && this.state.effectiveDate.parseJSONDate() >= this.state.currentDate.parseJSONDate()

        this.workdayDurationsEditor.renderTo(this.$workdayDurationsPlaceholder[0])
        this.workdayDurationsEditor.setInputDisabled(this.state.useDefaultSchedule && showCorporateCheckbox || this.state.readOnly)

        this.$totalCell.text(UserTime.formatTime(WorkdayDurationsEditor.sumDurations(this.state.durations)))

        this.useDefaultScheduleCheckbox.setState({
            checked: this.state.useDefaultSchedule,
            disabled: !showCorporateCheckbox
        })

        this.useDefaultScheduleCheckbox.toggle(showCorporateCheckbox)
        this.$usedDefaultScheduleLabel.toggle(this.state.readOnly && this.state.useDefaultSchedule)

        this.$deleteCell.toggle(!this.state.readOnly)
    }

    _handleScheduleChanged(changes) {
        const {
            oldEffectiveDate,
            effectiveDate,
            durations,
            useDefaultSchedule,
        } = {...this.state, ...changes}

        this.callbacks.onChangeCb({
            oldEffectiveDate,
            effectiveDate,
            durations,
            sameAsDefault: useDefaultSchedule,
        })
    }

    _toggleDeleteConfirmation(show) {
        this.$workschedule.toggle(!show)
        this.$deleteConfirmationContainer.toggle(show)

        if (show) {
            new DeleteConfirmationCell({
                deleteMessageKey: 'userlist.userdata.effective_date_row_delete_confirmation',
                onConfirm: () => this.callbacks.onDeleteCb({removePermanently: false}),
                onCancel: () => this._toggleDeleteConfirmation(false)
            }).init(this.find('.deleteConfirmationContainer'))
        } else {
            this.find('.deleteConfirmationContainer').empty()
        }
    }

    _updateError(error) {
        this.effectiveDate.setState({
            error: error && !!error[ValidationErrors.DUPLICATED_EFFECTIVE_DATE] ? ValidationErrors.DUPLICATED_EFFECTIVE_DATE : null,
            needShowWarning: error && error.showWarning === ShowWarning.EFFECTIVE_DATE_WARNING,
        })
    }

    _handleWorkdayDurationEditorError() {
        const $invalidWorkDayCell = this.find(`.${this.workdayDurationsEditor.getTableClassName()} td.error`)
        const msg = messageResource.getMessage('rates.editor.work_schedule.day_value.error', [window.SystemSettings.decimalSeparator]) + '\n' +
                    messageResource.getMessage('rates.editor.modifications_will_be_discarded')

        this.params.scrollTo($invalidWorkDayCell)

        const prevDurations = this.state.durations
        this.setStateInternal({durations: this.workdayDurationsEditor.getDurations()})

        getModalAlert().setState({
            text: msg,
            pointerPosition: ModalAlertPointerPosition.CENTER
        }).showAt($invalidWorkDayCell, () => {
            this.setState({durations: prevDurations})
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workSchedule/WorkScheduleRow.js